import Swiper from 'swiper';
import { Navigation, Pagination, Grid } from 'swiper/modules';

const mediaQuerySize = 600;
let swiperChapter: any = [];
const sliderElementsChapter = document.querySelectorAll('.swiper-chapter');

const sliderElements = document.querySelectorAll('.swiper');
sliderElements.forEach((element) => {
  let swiper = new Swiper(element, {
    slideClass: 'swiper-slide',
    direction: 'horizontal',
    slidesPerView: 1.08,
    spaceBetween: 16,
    breakpoints: {
      350: {
        slidesPerView: 1.08,
      },
      375: {
        slidesPerView: 1.1,
      },
      400: {
        slidesPerView: 1.2,
        spaceBetween: 16,
      },
      445: {
        slidesPerView: 1.3,
        spaceBetween: 16,
      },
      500: {
        slidesPerView: 1.4,
        spaceBetween: 16,
      },
      576: {
        slidesPerView: 1.6,
        spaceBetween: 16,
      },
      646: {
        slidesPerView: 1.8,
        spaceBetween: 16,
      },
      700: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      740: {
        slidesPerView: 2.2,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 2.1,
        spaceBetween: 24,
      },
      800: {
        slidesPerView: 1.7,
        spaceBetween: 24,
      },
      880: {
        slidesPerView: 1.9,
        spaceBetween: 24,
      },
      920: {
        slidesPerView: 2.1,
        spaceBetween: 24,
      },
      960: {
        slidesPerView: 2.2,
        spaceBetween: 24,
      },
      1015: {
        slidesPerView: 2.3,
        spaceBetween: 24,
      },
      1090: {
        slidesPerView: 2.4,
        spaceBetween: 24,
      },
      1178: {
        slidesPerView: 2.6,
        spaceBetween: 24,
      },
      1270: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
    },
  });
});

const sliderArrowElements = document.querySelectorAll('.swiper-arrow');
sliderArrowElements.forEach((element) => {
  let swiper = new Swiper(element, {
    slideClass: 'swiper-arr-slide',
    modules: [Navigation],
    direction: 'horizontal',

    navigation: {
      nextEl: '.swiper-arrow__button--next',
      prevEl: '.swiper-arrow__button--prev',
    },
    slidesPerView: 1.2,
    spaceBetween: 16,

    breakpoints: {
      500: {
        slidesPerView: 2.3,
        spaceBetween: 18,
      },

      1100: {
        // allowTouchMove: false,
        slidesPerView: 3,
        spaceBetween: 24,
      },
    },
  });
});

const swiperPagination = document.querySelector('.swiper-article') as HTMLElement;
const swiperArticle = new Swiper(swiperPagination, {
  slideClass: 'swiper-slide',
  modules: [Pagination, Navigation],
  navigation: {
    nextEl: '.swiper-arrow__button--next',
    prevEl: '.swiper-arrow__button--prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    renderBullet: function (index: number, className: string) {
      return `<button class="${className}" type="button"></button>`;
    },
  },
  breakpoints: {
    1100: {
      slidesPerView: 1,
    },
  },
});

// function swiperChapterInit() {
//   sliderElementsChapter.forEach((element: any) => {
//     const countsSlides = element.querySelectorAll('.swiper-slide').length;
//     console.log(countsSlides);
//     console.log(countsSlides);
//     const swiper = new Swiper(element, {
//       slideClass: 'swiper-slide',
//       slidesPerView: 1,
//       spaceBetween: 16,
//       allowSlideNext: false,
//       allowSlidePrev: false,
//       modules: [Grid],

//       grid: {},
//       breakpoints: {
//         600: {
//           slidesPerView: 2,
//           spaceBetween: 20,
//           grid: {
//             rows: countsSlides / 2,
//           },
//         },
//         1000: {
//           slidesPerView: 3,
//           spaceBetween: 24,
//           grid: {
//             rows: countsSlides / 3,
//           },
//         },
//       },
//     });

//     swiperChapter.push(swiper);
//   });
// }

// function swiperChapterDestroy() {
//   swiperChapter.forEach((swiper: any) => {
//     swiper.destroy();
//   });
//   swiperChapter = [];
// }

// window.addEventListener('load', () => {
//   const windowWidth = window.innerWidth;

//   if (windowWidth >= mediaQuerySize) {
//     swiperChapterInit();
//   } else {
//     swiperChapterDestroy();
//   }
// });

// window.addEventListener('resize', () => {
//   const windowWidth = window.innerWidth;
//   if (windowWidth >= mediaQuerySize) {
//     swiperChapterInit();
//   } else {
//     swiperChapterDestroy();
//   }
// });
